<template>
  <ul class="navbar__nav">
    <li>
      <RouterLink :to="t('routes.account.path')" class="navbar__navlink">{{ t('routes.account.name') }}</RouterLink>
    </li>
    <li>
      <RouterLink :to="t('routes.coproperty.path')" class="navbar__navlink">{{
          t('routes.coproperty.name')
        }}
      </RouterLink>
    </li>
    <li v-if="organization?.subscription.isActive">
      <RouterLink :to="t('routes.membership.path')" class="navbar__navlink">{{
          t('routes.membership.name')
        }}
      </RouterLink>
    </li>
    <li v-if="organization?.syndicate?.isActive">
      <RouterLink :to="t('routes.syndicate.path')" class="navbar__navlink">{{ t('routes.syndicate.name') }}</RouterLink>
    </li>
    <li>
      <RouterLink :to="t('routes.invoices.path')" class="navbar__navlink">{{ t('routes.invoices.name') }}</RouterLink>
    </li>
    <li>
      <RouterLink :to="t('routes.activities.path')" class="navbar__navlink">{{
          t('routes.activities.name')
        }}
      </RouterLink>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import {useI18n} from "vue3-i18n";
import {onMounted, ref} from "vue";
import {IFullOrganization} from "@/types/entities/organization";
import i18n from "@/i18n";
import {useOrganizationService} from "@/inversify.config";

const {t} = useI18n()

const organizationService = useOrganizationService()

const organization = ref<IFullOrganization>()

onMounted(async () => {
  let fullOrganization = await organizationService.getMyOrganization(i18n.getLocale())
  if (fullOrganization) {
    organization.value = fullOrganization
  }
})
</script>
